import { render, staticRenderFns } from "./GradesInquiryList.vue?vue&type=template&id=127354ed&scoped=true&"
import script from "./GradesInquiryList.vue?vue&type=script&lang=js&"
export * from "./GradesInquiryList.vue?vue&type=script&lang=js&"
import style0 from "./GradesInquiryList.vue?vue&type=style&index=0&id=127354ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127354ed",
  null
  
)

export default component.exports